<template>
    <div @click="clickEvent" class="modal_btn" :class="[isActive ? 'active' : '', isShowCount && isActive ? 'is_show_count' : '']">
        <div :style="{ color: disable ? '#d9d9d9' : '' }">{{ btnName }}</div>
        <div v-if="isActive && isShowCount" style="background-color: white; color:black; height:20px; border-radius:10px; padding:0px 5px; display:grid; place-items: center; margin-left:5px;">{{ count | comma }}</div>
        <div v-if="isShowXBtn && isActive && btnValue !== 'all'">
            <img style="width: 12px; margin-left: 6px;" :src="require('@/assets/img/X_btn_white.png')" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: "MercenaryModalBtn",
    props: {
        clickEvent: {
            type: Function,
            default: () => { }
        },
        btnName: {
            type: String,
            default: ''
        },
        isActive: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        count: {
            type: [Number, String],
            default: 0
        },
        isShowCount: {
            type: Boolean,
            default: false
        },
        isShowXBtn: {
            type: Boolean,
            default: false
        },
        btnValue: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped>
.modal_btn {
    height: 28px;
    padding: 0px 10px;
    border-radius: 14px;
    background-color: #f5f5f5;
    color: #210f03;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
}

.modal_btn.active {
    background-color: #210f03;
    color: #fff;

}

.is_show_count {
    padding: 0px 4px 0px 10px;
}
</style>
